import React, { useEffect, useState } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";

import { useRecoilState } from 'recoil';
import { outletAtom } from 'core/config/atoms';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import Lottie from 'lottie-react';
import moment from 'moment';

import ServiceHostel from 'services/serviceHostel';

import animBtnLoading from 'assets/anim/anim-btnLoading.json';

export default function ComponentHostelBookingPayment(props) {

    const hostelService = new ServiceHostel();

    const [outlet] = useRecoilState(outletAtom);

    const [submit, setSubmit] = useState(false);

    const formVSchema = Yup.object().shape({
        pending: Yup.number().required('This information is required'),
        payment: Yup.number().required('This information is required'),
    });

    const { values, errors, touched, handleChange, handleSubmit, handleReset, resetForm, setErrors, setValues } = useFormik({
        initialValues: {
            pending: 0,
            payment: 0,
        },
        validationSchema: formVSchema,
        enableReinitialize: true,
        onSubmit: values => {
            if (values.pending !== values.payment) {
                toast.error("Pending and payment must be same!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            } else {
                setSubmit(true);
                var body = {
                    "outletid": outlet.outletid.id,
                    "outlet": outlet.outletid.outletid,
                    "id": props.book._id,
                    "pending": values.pending,
                    "payment": values.payment,
                }
                hostelService.renewBed(body, '').then((res) => {
                    if (res.status) {
                        resetForm();
                        props.onClose();
                        toast.success('New payment booking added.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    } else {
                        toast.error(res.msg, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                    setSubmit(false);
                });
            }
        }
    });

    const getTitleSts = (sts) => {
        switch (sts) {
            case 'booked':
                return "Upcoming";
            case 'ongoing':
            case 'inprog':
                return "On-Going";
            default:
                return "NA";
        }
    }

    const getCssSts = (sts) => {
        switch (sts) {
            case 'booked':
                return "text-blue-600";
            case 'ongoing':
                return "text-yellow-600";
            case 'inprog':
                return "text-yellow-600";
            default:
                return "NA";
        }
    }

    const loadData = () => {
        (async function () {
            setValues({ ...values, pending: props.book.ptmRCAMT })
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className='overflow-y-auto overflow-x-hidden z-[400] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
            <div className='bg-white w-[40%] min-h-screen absolute right-0 p-[20px]'>
                <ScrollArea>
                    <div className='px-2'>
                        <div className='flex items-center justify-between text-2xl'>
                            <h1 className='font-sans font-medium text-gray-900 uppercase'>Hostel Booking Payment Form</h1>
                            <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => {
                                resetForm();
                                props.onClose();
                            }}>
                                <span><i className="las la-times text-xl cursor-pointer"></i></span>
                            </div>
                        </div>
                        <hr className='my-2' />
                        <form className='mt-4 grid grid-cols-12 gap-4' onSubmit={handleSubmit} onReset={handleReset} noValidate="" autoComplete='off'>
                            <div className="col-span-12 font-medium">
                                <p>Booking information</p>
                                <div className='w-full h-[1px] bg-gray-400 mt-1'></div>
                            </div>

                            <div className="col-span-12 border border-gray-300 rounded-lg p-4 bg-white flex items-start">
                                <div className="flex items-center space-x-2 mr-4">
                                    <div className='min-w-[100px] flex flex-col items-center border bg-gray-50 border-prime p-2 rounded-md space-y-3'>
                                        <p className='text-sm font-medium text-gray-600'>FROM</p>
                                        <p className='text-4xl font-medium'>{moment(props.book.checkIn).format('DD')}</p>
                                        <p className='text-sm font-medium text-gray-600 uppercase'>{moment(props.book.checkIn).format('ddd')}</p>
                                    </div>
                                    <div>-</div>
                                    <div className='min-w-[100px] flex flex-col items-center border bg-gray-50 border-prime p-2 rounded-md space-y-3'>
                                        <p className='text-sm font-medium text-gray-600'>TO</p>
                                        <p className='text-4xl font-medium'>{moment(props.book.checkOut).format('DD')}</p>
                                        <p className='text-sm font-medium text-gray-600 uppercase'>{moment(props.book.checkOut).format('ddd')}</p>
                                    </div>
                                </div>
                                <div className="flex flex-col items-start">
                                    <p className=''>Booking ID:&nbsp;<span className='font-medium'>{props.book.bookid}</span></p>
                                    <p className='text-sm'>Name:&nbsp;<span className='font-medium'>{props.book.customerId[0].name}</span></p>
                                    <p className='text-sm'>Status:&nbsp;<span className={`font-medium ${getCssSts(props.book.status)}`}>{(getTitleSts(props.book.status))}</span></p>
                                    <p className='text-sm'>Payment Due Date:&nbsp;<span className="font-medium text-prime">{moment(props.book.ptmDate).format('DD, MMM yyyy')}</span></p>
                                    <div className='flex-grow'></div>
                                </div>
                            </div>

                            <div className="col-span-12 font-medium">
                                <p>Payment information</p>
                                <div className='w-full h-[1px] bg-gray-400 mt-1'></div>
                            </div>

                            <div className="col-span-6">
                                <label className="block mb-2 text-sm font-medium text-gray-600">Pending Balance (₹)<sup className="text-red-600">*</sup></label>
                                <input type="number" id="pending" value={values.pending} autoComplete='off' readOnly className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. x" onChange={handleChange} />
                                {(errors.pending && touched.pending) && <p className='text-xs text-red-400 mt-1'>{errors.pending}</p>}
                            </div>

                            <div className="col-span-6">
                                <label className="block mb-2 text-sm font-medium text-gray-600">Payment Amount (₹)<sup className="text-red-600">*</sup></label>
                                <input type="number" id="payment" value={values.payment} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. x" onChange={handleChange} />
                                {(errors.payment && touched.payment) && <p className='text-xs text-red-400 mt-1'>{errors.payment}</p>}
                            </div>

                            <div className='col-span-12 my-4'>
                                <div className='flex items-end'>
                                    <button type="submit" className="text-white bg-prime hover:bg-primeLight focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center" disabled={submit}>
                                        {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                        {!submit && "Make Payment"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </ScrollArea >
            </div >
        </div>
    )
}
